import {moduleIcons} from '../../../ProjectContent/Icons/Icons'
import OdxModal from '../../../../OdxComponents/NativeOdx/Modal/Odx-Modal'
import * as React from 'react'
import {IListStaticModule} from '../../../../BackendFacade/IStaticModules'
import Documentation from '../../../Documentation/Documentation'
import {simplifyForHtmlId} from "../../../../Utils/transformer";

interface ShowDocumentationProps {
    isOpen: boolean
    onClose: () => void
    selectedModule: IListStaticModule
}

const ShowDocumentation: React.FC<ShowDocumentationProps> = ({isOpen, onClose, selectedModule}) => {
    const baseId = `hub-module-docs-${simplifyForHtmlId(selectedModule.staticModuleId)}`;
    return (
        <OdxModal
            variant={'sidesheet'}
            onClose={onClose}
            size={'small'}
            isOpen={isOpen}
            imgSrcInHeader={moduleIcons[selectedModule.staticModuleId] ? moduleIcons[selectedModule.staticModuleId] : moduleIcons['default']}
            footerButtons={[
                <odx-button
                    key="dismiss"
                    id={`${baseId}-dismiss-btn`}
                    variant="ghost"
                    size="lg"
                    type="button"
                    onClick={onClose}
                >
                    Dismiss
                </odx-button>
            ]}
            title={selectedModule.displayName}
            id={baseId}
        >
            <div id={`${baseId}-content`}>
                <Documentation component={selectedModule.staticModuleId}/>
            </div>
        </OdxModal>
    )
}
export default ShowDocumentation
